import { render, staticRenderFns } from "./PolicyResultsSummaryCard.vue?vue&type=template&id=78edc127&scoped=true"
import script from "./PolicyResultsSummaryCard.vue?vue&type=script&lang=ts"
export * from "./PolicyResultsSummaryCard.vue?vue&type=script&lang=ts"
import style0 from "./PolicyResultsSummaryCard.vue?vue&type=style&index=0&id=78edc127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78edc127",
  null
  
)

export default component.exports